module.exports = __webpack_public_path__ + "static/media/[Keats_and_Beats]2011-02-18.48c2381e.md";